import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import announceIcon from '../../../../assets/images/announce.svg';
import chevronLeft from '../../../../assets/images/chevron-left.svg';
import chevronRight from '../../../../assets/images/chevron-right.svg';
import styles from './Maintenance.module.less';

const Maintenance = ({ message }) => {
  const messages = [].concat(message).filter(Boolean);

  const [currentIndex, setCurrentIndex] = useState(0);
  const [resetKey, setResetKey] = useState(0);

  useEffect(() => {
    if (messages.length <= 1) {
      return () => {};
    }

    const timer = setInterval(() => {
      setCurrentIndex(prev => (prev + 1) % messages.length);
    }, 5000);

    return () => clearInterval(timer);
  }, [messages.length, resetKey]);

  if (messages.length === 0) {
    return null;
  }

  const handlePrev = () => {
    setCurrentIndex(prev => (prev - 1 + messages.length) % messages.length);
    setResetKey(prev => prev + 1);
  };

  const handleNext = () => {
    setCurrentIndex(prev => (prev + 1) % messages.length);
    setResetKey(prev => prev + 1);
  };

  const handleDotClick = index => {
    setCurrentIndex(index);
    setResetKey(prev => prev + 1);
  };

  return (
    <div className={styles.maintenance}>
      <div className={styles['tip-wrap']}>
        <img
          className={styles.announceImg}
          src={announceIcon}
          alt={announceIcon}
        />
        <div className={styles.tip}>{messages[currentIndex]}</div>
      </div>
      {messages.length > 1 && (
        <div className={styles.controls}>
          <div className={styles.arrow} onClick={handlePrev}>
            <img src={chevronLeft} alt='Previous' />
          </div>
          <div className={styles.dots}>
            {messages.map((msg, index) => (
              <div
                key={msg}
                className={`${styles.dot} ${
                  index === currentIndex ? styles.active : ''
                }`}
                onClick={() => handleDotClick(index)}
              />
            ))}
          </div>
          <div className={styles.arrow} onClick={handleNext}>
            <img src={chevronRight} alt='Next' />
          </div>
        </div>
      )}
    </div>
  );
};

Maintenance.propTypes = {
  message: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string)
  ]).isRequired
};

export default Maintenance;
